import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'

import {trans} from '@utils'

import Statistic from "../Statistic"
import _ from "lodash"

const StatisticAverageScore = props => {
  const {
    initOnMount = false,
    uri = null,
    withChart = true,
    chartType = 'area',
    vertical = false,
    height = 100,
    skeletonMinHeight,
    isDecimal = true
  } = props
  const {value, loading, stats} = useSelector(store => _.get(store, 'analytics.data.statistics_average_score'))

  const dispatch = useDispatch()

  useEffect(() => {
    if (initOnMount) {
      // _getAverageScore(uri)
    }
    return () => {
      // dispatch({
      //   type: 'ANALYTICS_CHARTS_DATA',
      //   payload: {
      //     average_score: {
      //       value: 0,
      //       loading: true,
      //       stats: []
      //     }
      //   }
      // })
    }
  }, [])

  const options = {
    tooltip: {
      y: {
        formatter (y) {
          if (typeof y !== "undefined") {
            return `${y.toFixed(2)}%`
          }
          return y.toFixed(0)
        },
        title: {
          formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
            return ''
          }
        }
      }
    }
  }

  return (
    <Statistic
      title={trans('analytics.actions.averageScore')}
      color={'primary'}
      data={stats}
      stats={`${value}%`}
      // icon={<User />}
      withChart={withChart}
      chartType={chartType}
      vertical={vertical}
      loading={loading}
      height={height}
      skeletonMinHeight={skeletonMinHeight}
      isDecimal={isDecimal}
      options={options}
    />
  )
}

StatisticAverageScore.propTypes = {}

export default StatisticAverageScore
